'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.heroSlider = twentyninetimes.heroSlider || function () {

	function init() {
		if (document.querySelector('.block-hero__slide')) {
			slider();
		}
	}

	function slider() {
		const slides = document.querySelectorAll('.block-hero__slide');
		const nextButton = document.querySelector('.slider-next');
		const prevButton = document.querySelector('.slider-prev');
		let currentSlide = 0;
		let isTransitioning = false; // Flag to indicate if a transition is in progress
		const transitionDuration = 800;

		// Function to lazy load and control video playback
		function manageMedia(slide, play = false) {
			const media = slide.querySelector('.block-hero__media');

			// Lazy load by moving data-src to src
			if (media && media.dataset.src) {
				media.src = media.dataset.src;
				media.removeAttribute('data-src');
			}

			if (media && media.tagName.toLowerCase() === 'video') {
				// Ensure the video is muted by default
				media.muted = true;

				if (play) {
					media.play(); // Play the video if the slide is active
				} else {
					media.pause(); // Pause the video when the slide is inactive
				}
			}
		}

		// Function to handle muting/unmuting videos
		function toggleMute(video) {
			video.muted = !video.muted;
		}

		// Show the slide with a smoother transition
		function showSlide(newIndex) {
			if (isTransitioning) return; // Prevent function execution if transitioning
			isTransitioning = true; // Set the flag to indicate transition has started

			const previousSlide = slides[currentSlide];
			const nextSlide = slides[newIndex];

			// Handle slide visibility and opacity
			previousSlide.classList.remove('active');
			previousSlide.classList.add('previous');
			nextSlide.classList.add('active');

			// Animate content
			nextSlide.querySelector('.block-hero__content').classList.add('animate-in');
			previousSlide.querySelector('.block-hero__content').classList.remove('animate-in');

			// Manage video playback
			manageMedia(previousSlide, false); // Pause the video of the previous slide
			manageMedia(nextSlide, true); // Play the video of the next slide

			// Disable arrow buttons during transition
			nextButton.disabled = true;
			prevButton.disabled = true;

			// Remove previous class after transition is done
			setTimeout(() => {
				previousSlide.classList.remove('previous');
				isTransitioning = false; // Transition is complete, allow navigation again
				nextButton.disabled = false;
				prevButton.disabled = false;
			}, transitionDuration);

			currentSlide = newIndex;
		}

		// Event listeners for next and previous buttons
		nextButton.addEventListener('click', () => {
			const newIndex = (currentSlide + 1) % slides.length;
			showSlide(newIndex);
		});

		prevButton.addEventListener('click', () => {
			const newIndex = (currentSlide - 1 + slides.length) % slides.length;
			showSlide(newIndex);
		});

		// Lazy load and initialize the first slide
		manageMedia(slides[currentSlide], true); // Play the media of the first slide
		slides[currentSlide].classList.add('active');
		slides[currentSlide].querySelector('.block-hero__content').classList.add('animate-in');

		// Adding mute/unmute functionality
		document.querySelectorAll('.mute-toggle').forEach(button => {
			button.addEventListener('click', (e) => {
				const video = e.target.closest('.block-hero__slide').querySelector('video');
				if (video) {
					toggleMute(video);
					e.target.classList.toggle('muted', video.muted); // Optionally toggle a class
				}
			});
		});
	}

	return {
		init: init
	};

}();